module.exports = __webpack_public_path__ + "static/img/planetEn4.83de4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planetEn4.png
// module id = q644
// module chunks = 1